import * as React from 'react';
import Bookmarks from './Bookmarks';
import { Container, Row, Col } from 'react-bootstrap';
import { ArticleType } from '../../models/article.model';
import { Link } from 'react-router-dom';


interface IBookmarkProps {
    bookmarks: ArticleType[]; // Assuming bookmarks is an array of any type
}

const Bookmark: React.FunctionComponent<IBookmarkProps> = ({ bookmarks }) => {
    return (
        <Container className='mt-5 py-4 blog-page' fluid="md" style={{ minHeight: "100vh" }}>
            <Row>
                <Col className='mt-5'>
                    <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                        <h1 className="h3 m-0">Your Bookmarks</h1>
                        <Link className="btn btn-outline-primary btn-sm" to="/blog">Back to blog</Link>
                    </div>
                    <Bookmarks bookmarks={bookmarks} />
                </Col>
            </Row>
        </Container>
    )
};
export default Bookmark;
